/* ZH gear PDP v3 (2026-10-01). Behaviour for the zh-gear-v3-* sections.
   Event delegation on document, so it works for any number of sections and
   after the theme editor re-renders a section.
   - Gallery: thumb rail (all product media, product videos included), the
     "See it in your hands" video mode, swipe, zoom dialog. Videos pause
     whenever they are left, hidden or scrolled away.
   - Buy box: quantity, free-gift colour, variant select, add to cart.
     Add to cart posts /cart/add.js with the main item plus the gift at the
     same quantity (the automatic discount makes the gift free; no per-order
     cap). snippets/zh-cart-sync opens the cart drawer after any OK
     /cart/add.js; without it we refresh/open the drawer ourselves.
   - Gift end: the hero carries data-zg3-gift-ends; past that moment the
     page drops the gift (copy, card and cart line) without a reload.
   - Paid extras: one-tap Add.  Jump links, film play button.
   v3.1: back-in-stock link follows the selected variant; jump links without
   a section on the page hide (fallback for browsers without CSS :has());
   product YouTube videos load only when played (youtube-nocookie).
   v3.2: stock line follows the variant; "Frequently bought together": ticked
   add-ons go into the same /cart/add.js call as the main item, colour buttons
   pick the add-on's variant (and tick it), the total and the free-shipping
   note follow the ticks, the quantity and the variant. */
(function () {
  if (window.__zg3) return;
  window.__zg3 = true;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function closest(el, s) { return el && el.closest ? el.closest(s) : null; }
  var HAS = false;
  try { HAS = CSS.supports('selector(:has(*))'); } catch (e) { HAS = false; }

  /* ---------------- gift state ---------------- */
  function giftOn(hero) { return !!hero && hero.getAttribute('data-zg3-gift') === 'on'; }
  function syncGiftCopy() {
    if (HAS) return;
    var off = !!$('[data-zg3-hero][data-zg3-gift="off"]');
    $$('[data-zg3-gift-only]').forEach(function (el) { el.hidden = off; });
    $$('[data-zg3-nogift-only]').forEach(function (el) { el.hidden = !off; });
  }
  function setGift(hero, on) {
    hero.setAttribute('data-zg3-gift', on ? 'on' : 'off');
    var btn = $('[data-zg3-add]', hero);
    if (btn && !btn.disabled) btn.textContent = on ? (btn.getAttribute('data-label-gift') || btn.textContent) : (btn.getAttribute('data-label') || btn.textContent);
    syncGiftCopy();
  }
  function checkGiftEnd() {
    $$('[data-zg3-hero][data-zg3-gift="on"]').forEach(function (h) {
      var end = Date.parse(h.getAttribute('data-zg3-gift-ends') || '');
      if (end && Date.now() >= end) setGift(h, false);
    });
  }

  /* ---------------- videos ---------------- */
  function pause(v) { try { if (v && !v.paused) v.pause(); } catch (e) {} }
  function play(v) {
    if (!v) return;
    $$('video').forEach(function (o) { if (o !== v) pause(o); });
    try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
  }
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (!en.isIntersecting || en.intersectionRatio < 0.2) pause(en.target); });
    }, { threshold: [0, 0.2] });
  }
  function watch() { if (io) $$('.zg3 video').forEach(function (v) { if (!v.__zg3io) { v.__zg3io = 1; io.observe(v); } }); }
  document.addEventListener('visibilitychange', function () { if (document.hidden) $$('.zg3 video').forEach(pause); });
  window.addEventListener('pagehide', function () { $$('.zg3 video').forEach(pause); });

  /* ---------------- gallery ---------------- */
  function thumbsOf(g) { return $$('[data-zg3-thumb]', g); }
  function current(g) { return parseInt(g.getAttribute('data-zg3-i') || '0', 10) || 0; }
  function show(g, i, autoplay) {
    var thumbs = thumbsOf(g);
    if (!thumbs.length) return;
    i = (i + thumbs.length) % thumbs.length;
    g.setAttribute('data-zg3-i', String(i));
    var t = thumbs[i];
    var frame = $('[data-zg3-frame]', g);
    var img = $('[data-zg3-hero-img]', g);
    $$('video', g).forEach(function (v) { pause(v); v.hidden = true; });
    thumbs.forEach(function (b, n) { b.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
    var vid = t.getAttribute('data-mvid');
    var v = vid ? $('[data-zg3-mvid="' + vid + '"]', g) : null;
    if (v) {
      if (img) img.hidden = true;
      v.hidden = false;
      frame.classList.add('is-video');
      if (autoplay) play(v);
    } else if (img) {
      frame.classList.remove('is-video');
      img.hidden = false;
      if (img.getAttribute('src') !== t.getAttribute('data-src')) {
        img.removeAttribute('srcset');
        img.src = t.getAttribute('data-src');
        if (t.getAttribute('data-srcset')) img.srcset = t.getAttribute('data-srcset');
      }
      img.alt = t.getAttribute('data-alt') || '';
    }
    var cap = $('[data-zg3-cap]', g);
    if (cap) {
      var alt = t.getAttribute('data-alt') || '';
      cap.textContent = (i + 1) + ' / ' + thumbs.length + (t.getAttribute('data-named') === '1' && alt ? ' · ' + alt : '');
    }
    var rail = $('[data-zg3-rail]', g);
    if (rail) {
      var l = t.offsetLeft - rail.offsetLeft;
      if (l < rail.scrollLeft) rail.scrollLeft = l - 4;
      else if (l + t.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = l + t.offsetWidth - rail.clientWidth + 4;
    }
  }
  function mode(g, m, autoplay) {
    var hand = $('[data-zg3-hand]', g);
    var frame = $('[data-zg3-frame]', g);
    $$('[data-zg3-mode]', g).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-zg3-mode') === m ? 'true' : 'false'); });
    if (m === 'hand' && hand) {
      g.classList.add('is-hand');
      $$('video', g).forEach(function (v) { if (v !== hand) { pause(v); v.hidden = true; } });
      var img = $('[data-zg3-hero-img]', g);
      if (img) img.hidden = true;
      hand.hidden = false;
      frame.classList.add('is-video');
      if (autoplay) play(hand);
    } else {
      g.classList.remove('is-hand');
      if (hand) { pause(hand); hand.hidden = true; }
      show(g, current(g), false);
    }
  }

  /* zoom */
  function zoomImages(g) { return thumbsOf(g).filter(function (t) { return !t.getAttribute('data-mvid') && t.getAttribute('data-full'); }); }
  function openZoom(g) {
    var d = $('[data-zg3-zoom]', g);
    var list = zoomImages(g);
    if (!d || !list.length) return;
    var t = thumbsOf(g)[current(g)];
    var k = Math.max(0, list.indexOf(t));
    setZoom(g, k);
    if (typeof d.showModal === 'function') { try { d.showModal(); } catch (e) { d.setAttribute('open', ''); } } else { d.setAttribute('open', ''); }
  }
  function setZoom(g, k) {
    var d = $('[data-zg3-zoom]', g);
    var list = zoomImages(g);
    if (!d || !list.length) return;
    k = (k + list.length) % list.length;
    d.setAttribute('data-k', String(k));
    var zi = $('img', d);
    zi.src = list[k].getAttribute('data-full');
    zi.alt = list[k].getAttribute('data-alt') || '';
    var multi = list.length > 1;
    $$('.zg3-zoom__prev, .zg3-zoom__next', d).forEach(function (b) { b.hidden = !multi; });
  }
  function closeZoom(d) { if (!d) return; if (typeof d.close === 'function' && d.open) d.close(); else d.removeAttribute('open'); }

  /* swipe */
  var sx = 0, sy = 0, sg = null;
  document.addEventListener('touchstart', function (e) {
    var f = closest(e.target, '[data-zg3-frame]');
    sg = f ? closest(f, '[data-zg3-gal]') : null;
    if (!sg || sg.classList.contains('is-hand') || closest(e.target, 'video')) { sg = null; return; }
    sx = e.touches[0].clientX; sy = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!sg) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) show(sg, current(sg) + (dx < 0 ? 1 : -1), false);
    sg = null;
  }, { passive: true });

  /* ---------------- buy box ---------------- */
  function qtyInput(hero) { return $('[data-zg3-qtyin]', hero); }
  function getQty(hero) {
    var q = qtyInput(hero);
    var n = q ? parseInt(q.value, 10) : 1;
    if (!n || n < 1) n = 1;
    if (n > 99) n = 99;
    return n;
  }
  function setQty(hero, n) {
    var q = qtyInput(hero);
    if (!q) return;
    n = Math.max(1, Math.min(99, n || 1));
    q.value = n;
    $$('[data-zg3-gift-qty]', hero).forEach(function (el) { el.textContent = n > 1 ? ' × ' + n : ''; });
    fbtUpdate(hero);
  }

  /* ---------------- frequently bought together ---------------- */
  function fbtUpdate(hero) {
    var box = hero && $('[data-zg3-fbt]', hero);
    if (!box) return;
    var main = $('[data-zg3-fbt-main]', box);
    var unit = main ? parseInt(main.getAttribute('data-price') || '0', 10) || 0 : 0;
    var q = getQty(hero);
    var base = unit * q;
    if (main) main.textContent = (q > 1 ? q + ' × ' : '') + money(unit);
    var total = base;
    $$('[data-zg3-fbt-cb]', box).forEach(function (cb) {
      var item = closest(cb, '[data-zg3-fbt-item]');
      if (item) item.classList.toggle('is-on', cb.checked);
      if (cb.checked) total += parseInt(cb.getAttribute('data-price') || '0', 10) || 0;
    });
    var t = $('[data-zg3-fbt-total]', box);
    if (t) t.textContent = money(total);
    var ship = $('[data-zg3-fbt-ship]', box);
    var at = parseInt(box.getAttribute('data-free-at') || '0', 10) || 0;
    if (ship && at) {
      if (unit >= at) { ship.hidden = true; return; }
      ship.hidden = false;
      var ok = total >= at;
      ship.classList.toggle('is-ok', ok);
      ship.textContent = ok ? (box.getAttribute('data-ok') || '') : (box.getAttribute('data-gap') || '').replace('[amount]', money(at - total));
    }
  }
  function fbtChecked(hero) {
    var box = $('[data-zg3-fbt]', hero);
    if (!box || box.hidden) return [];
    return $$('[data-zg3-fbt-cb]', box).filter(function (cb) { return cb.checked && parseInt(cb.value, 10); });
  }
  function note(hero, kind, msg) {
    var n = $('[data-zg3-note]', hero);
    var live = $('[data-zg3-live]', hero);
    if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 60); }
    if (!n) return;
    clearTimeout(n.__t);
    n.textContent = msg;
    n.classList.toggle('is-err', kind === 'err');
    n.hidden = false;
    if (kind !== 'err') n.__t = setTimeout(function () { n.hidden = true; }, 6000);
  }
  function busy(btn, on) {
    if (!btn) return;
    if (on) {
      btn.__label = btn.textContent;
      btn.classList.add('is-busy');
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-label-busy') || 'Adding…';
    } else {
      btn.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      if (btn.__label) btn.textContent = btn.__label;
    }
  }
  function cartAdd(items) {
    return window.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var err = new Error((j && (j.description || j.message)) || 'Add to cart failed'); err.zg3 = j; throw err; }
        return j;
      });
    });
  }
  function afterAdd() {
    if (!window.__zhCartSync) {
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })); } catch (e) {}
    }
    setTimeout(function () {
      if (!document.querySelector('cart-drawer, #CartDrawer')) window.location.href = '/cart';
    }, 1200);
  }
  function selectedGift(hero) {
    var b = $('[data-zg3-gift-variant][aria-pressed="true"]', hero) || $('[data-zg3-gift-variant]', hero);
    return b ? parseInt(b.getAttribute('data-zg3-gift-variant'), 10) : (parseInt(hero.getAttribute('data-zg3-gift-vid') || '', 10) || 0);
  }
  function submitBuy(form) {
    var hero = closest(form, '[data-zg3-hero]');
    if (!hero) return;
    checkGiftEnd();
    var btn = $('[data-zg3-add]', form);
    if (btn && btn.disabled) return;
    var idIn = form.querySelector('[name="id"]');
    var id = idIn ? parseInt(idIn.value, 10) : 0;
    if (!id) return;
    var q = getQty(hero);
    var items = [{ id: id, quantity: q }];
    var gid = giftOn(hero) ? selectedGift(hero) : 0;
    var gname = '';
    if (gid) {
      items.push({ id: gid, quantity: q });
      var gb = $('[data-zg3-gift-variant][aria-pressed="true"]', hero);
      gname = gb ? (gb.getAttribute('data-label') || '') : '';
    }
    var extras = fbtChecked(hero);
    extras.forEach(function (cb) { items.push({ id: parseInt(cb.value, 10), quantity: 1 }); });
    var n = $('[data-zg3-note]', hero);
    if (n) n.hidden = true;
    busy(btn, true);
    cartAdd(items).then(function () {
      busy(btn, false);
      var title = hero.getAttribute('data-zg3-title') || 'Item';
      var msg = 'Added to your cart: ' + (q > 1 ? q + ' × ' : '') + title;
      if (gid) msg += ' + ' + (q > 1 ? q + ' free ' : 'free ') + (gname ? gname.toLowerCase() + ' ' : '') + (hero.getAttribute('data-zg3-gift-noun') || 'gift') + (q > 1 ? 's' : '');
      extras.forEach(function (cb) { msg += ' + ' + (cb.getAttribute('data-title') || 'add-on'); cb.checked = false; });
      fbtUpdate(hero);
      note(hero, 'ok', msg + '.');
      afterAdd();
    }).catch(function (err) {
      busy(btn, false);
      note(hero, 'err', (err && err.message && err.message !== 'Failed to fetch') ? err.message : 'We couldn’t add that to your cart. Please try again.');
    });
  }
  function variantData(hero) {
    if (hero.__zg3v) return hero.__zg3v;
    var el = $('[data-zg3-variants]', hero);
    var list = [];
    try { list = JSON.parse(el ? el.textContent : '[]'); } catch (e) { list = []; }
    hero.__zg3v = list;
    return list;
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function onVariant(sel) {
    var hero = closest(sel, '[data-zg3-hero]');
    if (!hero) return;
    var id = parseInt(sel.value, 10);
    var v = null;
    variantData(hero).forEach(function (x) { if (x.id === id) v = x; });
    if (!v) return;
    var form = $('form.zg3-form', hero);
    var idIn = form && form.querySelector('[name="id"]');
    if (idIn) idIn.value = id;
    var p = $('[data-zg3-price]', hero);
    if (p) p.textContent = money(v.price);
    var c = $('[data-zg3-compare]', hero);
    if (c) { c.textContent = v.compare > v.price ? money(v.compare) : ''; c.hidden = !(v.compare > v.price); }
    var btn = $('[data-zg3-add]', hero);
    if (btn) {
      btn.disabled = !v.available;
      btn.textContent = !v.available ? (btn.getAttribute('data-label-sold') || 'Sold out') : (giftOn(hero) ? btn.getAttribute('data-label-gift') : btn.getAttribute('data-label'));
    }
    var bis = $('[data-zg3-bis]', hero);
    if (bis) bis.hidden = !v.bis;
    var pay = $('[data-zg3-pay]', hero);
    if (pay) pay.hidden = !v.available;
    var st = $('[data-zg3-stock]', hero);
    if (st && v.st) { st.className = 'zg3-stock is-' + v.st; st.textContent = st.getAttribute('data-' + v.st) || st.textContent; }
    var fm = $('[data-zg3-fbt-main]', hero);
    if (fm) { fm.setAttribute('data-price', String(v.price)); fbtUpdate(hero); }
    var fb = $('[data-zg3-fbt]', hero);
    if (fb) fb.hidden = !v.available;
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', String(id));
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  /* ---------------- scrolling ---------------- */
  function scrollToEl(el) {
    if (!el) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); } catch (e) { el.scrollIntoView(); }
  }
  function jumpObserver() {
    var nav = $('[data-zg3-jump]');
    if (!nav || !('IntersectionObserver' in window) || nav.__zg3) return;
    nav.__zg3 = 1;
    var links = $$('a[href^="#"]', nav);
    var map = {};
    links.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t) map[t.id] = a; });
    var vis = {};
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { vis[en.target.id] = en.isIntersecting ? en.boundingClientRect.top : null; });
      var best = null, bestTop = Infinity;
      Object.keys(vis).forEach(function (k) { if (vis[k] !== null && vis[k] < bestTop) { bestTop = vis[k]; best = k; } });
      links.forEach(function (a) { a.classList.toggle('is-active', !!best && map[best] === a); });
    }, { rootMargin: '-35% 0px -55% 0px' });
    Object.keys(map).forEach(function (k) { obs.observe(document.getElementById(k)); });
  }

  function jumpTargets() {
    if (HAS) return;
    $$('[data-zg3-jump]').forEach(function (nav) {
      var shown = 0;
      $$('a[href^="#"]', nav).forEach(function (a) {
        var ok = !!document.getElementById(a.getAttribute('href').slice(1));
        a.hidden = !ok;
        if (ok) shown++;
      });
      nav.hidden = shown === 0;
    });
  }

  /* ---------------- product YouTube video (click to load) ---------------- */
  function ytPlay(box) {
    if (!box || box.__zg3yt) return;
    var id = box.getAttribute('data-zg3-yt') || '';
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    box.__zg3yt = 1;
    $$('video').forEach(pause);
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
    f.title = box.getAttribute('data-zg3-yt-title') || 'Video';
    f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    box.textContent = '';
    box.appendChild(f);
    box.classList.add('is-playing');
  }

  /* ---------------- clicks ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;

    if (closest(t, '.klaviyo-bis-trigger')) return; /* Klaviyo's back-in-stock form handles its own link */

    if ((el = closest(t, '[data-zg3-thumb]'))) {
      var g = closest(el, '[data-zg3-gal]');
      if (g.classList.contains('is-hand')) { g.classList.remove('is-hand'); var h = $('[data-zg3-hand]', g); if (h) { pause(h); h.hidden = true; } $$('[data-zg3-mode]', g).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-zg3-mode') === 'photo' ? 'true' : 'false'); }); }
      show(g, thumbsOf(g).indexOf(el), true);
      return;
    }
    if ((el = closest(t, '[data-zg3-mode]'))) {
      mode(closest(el, '[data-zg3-gal]'), el.getAttribute('data-zg3-mode'), true);
      return;
    }
    if ((el = closest(t, '[data-zg3-zoom-open], [data-zg3-hero-img]'))) {
      openZoom(closest(el, '[data-zg3-gal]'));
      return;
    }
    if ((el = closest(t, '[data-zg3-zoom]'))) {
      var gz = closest(el, '[data-zg3-gal]');
      var k = parseInt(el.getAttribute('data-k') || '0', 10);
      if (closest(t, '.zg3-zoom__prev')) { setZoom(gz, k - 1); return; }
      if (closest(t, '.zg3-zoom__next')) { setZoom(gz, k + 1); return; }
      if (closest(t, '.zg3-zoom__close') || t === el) { closeZoom(el); return; }
      return;
    }
    if ((el = closest(t, '[data-zg3-qty]'))) {
      var hq = closest(el, '[data-zg3-hero]');
      setQty(hq, getQty(hq) + parseInt(el.getAttribute('data-zg3-qty'), 10));
      return;
    }
    if ((el = closest(t, '[data-zg3-fbt-var]'))) {
      e.preventDefault();
      var it = closest(el, '[data-zg3-fbt-item]');
      if (!it) return;
      $$('[data-zg3-fbt-var]', it).forEach(function (b) { b.setAttribute('aria-pressed', b === el ? 'true' : 'false'); });
      var vprice = el.getAttribute('data-price') || '0';
      var cbx = $('[data-zg3-fbt-cb]', it);
      if (cbx) { cbx.value = el.getAttribute('data-zg3-fbt-var'); cbx.setAttribute('data-price', vprice); cbx.checked = true; }
      var pr = $('[data-zg3-fbt-price]', it);
      if (pr) pr.textContent = money(parseInt(vprice, 10) || 0);
      var fim = $('[data-zg3-fbt-img]', it);
      if (fim && el.getAttribute('data-img')) fim.src = el.getAttribute('data-img');
      fbtUpdate(closest(el, '[data-zg3-hero]'));
      return;
    }
    if ((el = closest(t, '[data-zg3-fbt-info]'))) {
      e.preventDefault();
      var dsc = document.getElementById(el.getAttribute('aria-controls') || '');
      var opn = el.getAttribute('aria-expanded') !== 'true';
      el.setAttribute('aria-expanded', opn ? 'true' : 'false');
      if (dsc) dsc.hidden = !opn;
      return;
    }
    if ((el = closest(t, '[data-zg3-gift-variant]'))) {
      e.preventDefault();
      var hero = closest(el, '[data-zg3-hero]');
      $$('[data-zg3-gift-variant]', hero).forEach(function (b) { b.setAttribute('aria-pressed', b === el ? 'true' : 'false'); });
      hero.setAttribute('data-zg3-gift-vid', el.getAttribute('data-zg3-gift-variant'));
      var src = el.getAttribute('data-img');
      var label = el.getAttribute('data-label') || '';
      $$('[data-zg3-gift-img]').forEach(function (im) {
        if (src) { im.removeAttribute('srcset'); im.src = src; }
        im.alt = (label ? label + ' ' : '') + (im.getAttribute('data-base-alt') || '');
      });
      $$('[data-zg3-gift-color]').forEach(function (s) { s.textContent = label; });
      return;
    }
    if ((el = closest(t, '[data-zg3-extra-add]'))) {
      e.preventDefault();
      if (el.disabled) return;
      var vid = parseInt(el.getAttribute('data-zg3-extra-add'), 10);
      var lbl = el.textContent;
      el.disabled = true;
      el.textContent = 'Adding…';
      cartAdd([{ id: vid, quantity: 1 }]).then(function () {
        el.textContent = 'Added';
        el.classList.add('is-done');
        afterAdd();
        setTimeout(function () { el.disabled = false; el.classList.remove('is-done'); el.textContent = lbl; }, 2600);
      }).catch(function (err) {
        el.disabled = false;
        el.textContent = lbl;
        var sec = closest(el, '[data-zg3-extras]');
        var n = sec && $('[data-zg3-extras-note]', sec);
        if (n) { n.textContent = (err && err.message && err.message !== 'Failed to fetch') ? err.message : 'We couldn’t add that. Please try again.'; n.hidden = false; }
      });
      return;
    }
    if ((el = closest(t, '[data-zg3-to-buy]'))) {
      e.preventDefault();
      var hb = $('[data-zg3-hero]');
      if (!hb) return;
      scrollToEl(hb);
      var add = $('[data-zg3-add]', hb);
      if (add) setTimeout(function () { try { add.focus({ preventScroll: true }); } catch (x) {} }, 450);
      return;
    }
    if ((el = closest(t, '[data-zg3-film-jump]'))) {
      e.preventDefault();
      var fid = (el.getAttribute('href') || '').slice(1);
      var fsec = fid && document.getElementById(fid);
      if (fsec) {
        scrollToEl(fsec);
        var fyb = $('[data-zg3-yt]', fsec);
        if (fyb) ytPlay(fyb);
        else { var fv = $('video', fsec); if (fv) play(fv); }
      }
      return;
    }
    if ((el = closest(t, '[data-zg3-yt-play]'))) {
      e.preventDefault();
      ytPlay(closest(el, '[data-zg3-yt]'));
      return;
    }
    if ((el = closest(t, '[data-zg3-play]'))) {
      e.preventDefault();
      var sec2 = closest(el, '[data-zg3-sec]');
      var v = sec2 && $('video', sec2);
      if (v) { if (v.paused) play(v); else pause(v); return; }
      var yb = sec2 && $('[data-zg3-yt]', sec2);
      if (yb) { ytPlay(yb); try { yb.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (x) {} }
      return;
    }
    if ((el = closest(t, 'a[href^="#"]')) && closest(el, '.zg3')) {
      var id = el.getAttribute('href').slice(1);
      var target = id && document.getElementById(id);
      if (target) {
        e.preventDefault();
        var d = closest(target, 'details') || (target.tagName === 'DETAILS' ? target : null);
        if (d && !d.open) d.open = true;
        scrollToEl(target);
      }
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('zg3-form')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    submitBuy(form);
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-zg3-qtyin')) setQty(closest(t, '[data-zg3-hero]'), parseInt(t.value, 10));
    if (t && t.hasAttribute && t.hasAttribute('data-zg3-variant')) onVariant(t);
    if (t && t.hasAttribute && t.hasAttribute('data-zg3-fbt-cb')) fbtUpdate(closest(t, '[data-zg3-hero]'));
  });

  document.addEventListener('keydown', function (e) {
    var d = $('[data-zg3-zoom][open]');
    if (!d) return;
    var g = closest(d, '[data-zg3-gal]');
    var k = parseInt(d.getAttribute('data-k') || '0', 10);
    if (e.key === 'ArrowLeft') { setZoom(g, k - 1); e.preventDefault(); }
    else if (e.key === 'ArrowRight') { setZoom(g, k + 1); e.preventDefault(); }
  });

  function init() {
    checkGiftEnd();
    syncGiftCopy();
    watch();
    jumpTargets();
    jumpObserver();
    $$('[data-zg3-hero]').forEach(fbtUpdate);
  }
  window.addEventListener('pageshow', function () { $$('[data-zg3-hero]').forEach(fbtUpdate); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setInterval(checkGiftEnd, 60000);
  document.addEventListener('shopify:section:load', function () { init(); });
})();
